'use es6';

import memoize from './memoize';
export const getHubSpotFeatureGroupI18nKey = (key, isUngatedForContentHub = false) => {
  if (key === 'CMS' && isUngatedForContentHub) {
    return 'ecosystemMarketplaceCore.groupTags.hubspotFeatureGroups.CONTENT';
  }
  return `ecosystemMarketplaceCore.groupTags.hubspotFeatureGroups.${key}`;
};
export const getHubSpotFeatureI18nKey = key => {
  return `marketplace-ui-common.groupTags.hubspotFeature.${key}`;
};
export const getDataSyncsDataI18nKey = data => {
  return `ecosystemMarketplaceCore.dataSyncs.data.${data}`;
};
export const getDataSyncsSyncI18nKey = sync => {
  return `ecosystemMarketplaceCore.dataSyncs.sync.${sync}`;
};
export const getAssetBusinessTypeI18nKey = (businessType, sentenceCase = true) => `ecosystemMarketplaceCore.assets.businessType.${businessType}.${sentenceCase ? 'sentence' : 'title'}`;
export const getAssetPageTypeI18nKey = (pageType, sentenceCase = true) => `ecosystemMarketplaceCore.assets.pageType.${pageType}.${sentenceCase ? 'sentence' : 'title'}`;
export const getAssetPageFeatureI18nKey = (feature, sentenceCase = true) => `ecosystemMarketplaceCore.assets.pageFeature.${feature}.${sentenceCase ? 'sentence' : 'title'}`;
export const getRoleI18nKey = memoize((role, portalScopes) => {
  let key = role.toLowerCase().replace(/ /g, '-');
  if (portalScopes) {
    if (portalScopes.includes('sales-nav-access')) {
      key += '-sales';
    } else if (portalScopes.includes('service-access')) {
      key += '-service';
    }
  }
  return `roles.${key}`;
});